<button class="dialog-header-close" mat-icon-button (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
<div class="dialog-header">
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="43" height="43" rx="7.5" stroke="#FF842B"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M30.4871 13.5039C29.3777 12.3904 28.0589 11.5076 26.6066 10.9062C25.1543 10.3049 23.5974 9.99687 22.0255 10C21.8138 10 21.6107 10.0841 21.461 10.2338C21.3113 10.3835 21.2272 10.5865 21.2272 10.7982C21.2272 11.0098 21.3113 11.2129 21.461 11.3625C21.6107 11.5122 21.8138 11.5963 22.0255 11.5963C23.3957 11.5963 24.7524 11.8675 26.0172 12.3944C27.282 12.9214 28.4299 13.6935 29.3947 14.6663C30.3595 15.6391 31.122 16.7933 31.6383 18.0623C32.1547 19.3314 32.4145 20.69 32.4029 22.06C32.4029 22.2717 32.487 22.4747 32.6367 22.6244C32.7864 22.774 32.9895 22.8581 33.2012 22.8581C33.4129 22.8581 33.6159 22.774 33.7656 22.6244C33.9153 22.4747 33.9994 22.2717 33.9994 22.06C34.0147 20.4716 33.7118 18.8963 33.1086 17.4268C32.5054 15.9573 31.614 14.6235 30.4871 13.5039ZM27.9734 25.9121C27.7509 25.6889 27.4865 25.5117 27.1954 25.3909C26.9043 25.27 26.5922 25.2078 26.2771 25.2078C25.9619 25.2078 25.6498 25.27 25.3587 25.3909C25.0676 25.5117 24.8032 25.6889 24.5807 25.9121L23.4233 27.0694C22.12 26.2424 20.9126 25.2734 19.8231 24.1801C18.7297 23.0908 17.7605 21.8835 16.9334 20.5805L18.0909 19.4232C18.3141 19.2007 18.4913 18.9364 18.6121 18.6453C18.733 18.3543 18.7952 18.0423 18.7952 17.7271C18.7952 17.412 18.733 17.0999 18.6121 16.8089C18.4913 16.5178 18.3141 16.2535 18.0909 16.0311L15.8318 13.7803C15.6124 13.5563 15.3503 13.3787 15.061 13.2581C14.7716 13.1374 14.4609 13.0762 14.1474 13.0779C13.8317 13.0772 13.519 13.1388 13.2272 13.2593C12.9353 13.3799 12.6703 13.5569 12.4471 13.7803L11.3615 14.8578C10.8441 15.4141 10.4579 16.0792 10.2313 16.8044C10.0048 17.5295 9.9436 18.2962 10.0524 19.048C10.3078 22.0411 12.2715 25.6407 15.2969 28.6737C18.3224 31.7066 21.9624 33.6621 24.9559 33.9494C25.1793 33.9613 25.4031 33.9613 25.6265 33.9494C26.2708 33.9764 26.9141 33.8746 27.5186 33.6498C28.1231 33.4251 28.6767 33.0819 29.1468 32.6404L30.2245 31.555C30.4479 31.3319 30.6249 31.0668 30.7455 30.7751C30.866 30.4833 30.9277 30.1706 30.9269 29.8549C30.9287 29.5415 30.8674 29.2309 30.7468 28.9415C30.6261 28.6522 30.4485 28.3901 30.2245 28.1708L27.9734 25.9121ZM27.0031 19.6487C26.7605 19.058 26.4021 18.5217 25.9491 18.0715C25.5077 17.6233 24.9823 17.2664 24.4029 17.0213C23.8235 16.7761 23.2015 16.6475 22.5724 16.6428C22.3607 16.6428 22.1577 16.5587 22.008 16.409C21.8582 16.2593 21.7741 16.0563 21.7741 15.8446C21.7741 15.633 21.8582 15.4299 22.008 15.2803C22.1577 15.1306 22.3607 15.0465 22.5724 15.0465C23.4178 15.0464 24.2548 15.2142 25.0348 15.54C25.8149 15.8659 26.5225 16.3434 27.1165 16.9448C27.7106 17.5462 28.1793 18.2595 28.4955 19.0434C28.8117 19.8274 28.9691 20.6663 28.9585 21.5115C28.9585 21.7231 28.8744 21.9261 28.7247 22.0758C28.575 22.2255 28.372 22.3096 28.1603 22.3096C27.9485 22.3096 27.7455 22.2255 27.5958 22.0758C27.4461 21.9261 27.362 21.7231 27.362 21.5115C27.3678 20.8728 27.2458 20.2395 27.0031 19.6487Z" fill="#FF842B"/>
    </svg>
    &nbsp;    &nbsp;    
    <div>
      <h2>{{ data.title }}</h2>
      <p>{{ data.subtitle }}</p>
    </div>
   
  </div>
  
  <div class="dialog-content">
    <div class="date-time">
      <div>
        <label>Date</label>
        <div>{{ data.date }}</div>
      </div>
      <div style="font-size: 12px;">
        <label>Time</label>
        <div>{{ data.time }} ({{ data.duration }})</div>
      </div>
    </div>
  <hr>
    <div class="participants">
      <label>Participants</label>
      <div class="participantsGroup" style="font-size: 12px;">
      <div *ngFor="let p of data.event_attendees" class="participant">
        <span>
          {{ p.name }} 
          <span *ngIf="p.isYou">(you)</span>
          <span class="rolep" [ngStyle]="{'color': p.roleColor}">
            {{ p.role }}
          </span>
        </span>
        <span class="status">{{ p.status }}</span>
      </div>
    </div>
    </div>
  
    <div class="description">
      <label>Description</label>
      <span style="font-size: 12px;white-space: normal;word-break: break-word; overflow-wrap: anywhere;">
          {{'Link to a meeting :'}} <a [href]="data.meetingLink" target="_blank">{{ data.meetingLink }}</a>
      </span>
      <p class="p-2 text-sm">
        {{ data.description }}
      </p>
      
    </div>
  </div>
  <hr>
  <div class="dialog-footer">
    <span style="font-size: 12px;">Invited by <br><strong>{{ data.invitedBy }}</strong></span>
    <div style="display: flex;gap:10px" *ngIf="data.diaplayActions && this.username != data.createdBy && (this.userData?.status != 'accepted' && this.userData?.status != 'rejected')">
        <button mat-raised-button color="warn" mat-dialog-close (click)="onReject()">Reject</button>
        <button mat-raised-button color="primary" mat-dialog-close (click)="onAccept()">Accept</button>

    </div>
    <div style="display: flex;gap:10px" *ngIf="data.diaplayActions&&this.username != data.createdBy&&this.userData?.status=='accepted'" >
      <button mat-raised-button style="background: green; color:#fff"  >Accepted</button>
  </div>
  <div style="display: flex;gap:10px" *ngIf="data.diaplayActions&&this.username != data.createdBy&&this.userData?.status=='rejected'" >
    <button mat-raised-button style="background: red; color:#fff"  >Rejected</button>
    <button mat-raised-button color="warn" mat-dialog-close (click)="onDelete()">Delete</button>

</div>
    <div style="display: flex;gap:10px" *ngIf=" data.diaplayActions&&this.username == data.createdBy">
      <button mat-raised-button color="warn" mat-dialog-close (click)="onDelete()">Delete</button>
      <button mat-raised-button color="primary"mat-dialog-close (click)="onEdit()">Edit</button>
  </div>
  </div>
  